// extracted by mini-css-extract-plugin
module.exports = {"root":"CopyToClipboardButton_root__VZw5k"};